import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicePage from "../pages/services/ServicePage";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfService from "../pages/terms-of-service/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pool-leak-detection-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/water-leak-detection-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/home-repiping-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/mainline-replacement-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/slab-leak-repair-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/emergency-plumbing-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/water-heater-installation-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/water-filtration-softener-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/garbage-disposal-repair-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/water-damage-restoration-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/sewer-line-repair-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/drain-cleaning-las-vegas",
    element: <ServicePage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
